var _style, _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcademy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 120 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes colorChange {\n      0% {\n        stroke: black; \n      }\n      25% {\n        stroke: #FF9F31;\n      }\n      50% {\n        stroke: #FF9F31;\n      }\n      75% {\n        stroke: #FFFFFF;\n      }\n      100% {\n        stroke: black;\n      }\n    }\n\n    path {\n      animation: colorChange 4s infinite;\n      transition: stroke 0.3s ease-in-out;\n    }\n\n    path:nth-of-type(1) {\n      animation-delay: 1s; \n    }\n\n    path:nth-of-type(2) {\n      animation-delay: 0.5s;\n    }\n\n    path:nth-of-type(3) {\n      animation-delay: 0.5s;\n    }\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.6209 88.0053V47.8013L65.7412 30.7485",
    stroke: "black",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0117 54.1256L71.6146 64.7413L90.926 52.5446",
    stroke: "black",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6501 85.7466H39.3151C36.1965 85.7466 33.6684 83.2185 33.6684 80.1V74.3404V51.5859C33.6684 48.5315 32.0862 45.6951 29.4872 44.0905L9 31.4421L23.5 24.9421",
    stroke: "black",
    strokeWidth: 8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91992 31.9908L67.2094 5L130 30.8615L106.397 43.397",
    stroke: "black",
    strokeWidth: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99.5083,
    cy: 96.7009,
    r: 3.95263,
    fill: "#051A2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademy);
export default __webpack_public_path__ + "static/media/academy.5b537f66c8449b0080baa160174c6e2d.svg";
export { ForwardRef as ReactComponent };